import React from 'react';
import PageTemplate from '../../components/PageTemplate';
const MLOps = () => {
  return <PageTemplate title="MLOps" subtitle="ML Operations & Deployment" breadcrumb="AI & Data > MLOps"><div className="content-section"><p>Model deployment, monitoring, and machine learning operations services.</p></div></PageTemplate>;
};
export default MLOps; 